import { QUERY_KEYS, SOCKET_EVENTS } from "@cnx/common";
import { useEffect } from "react";
import { useAuthStore } from "stores/authStore";
import { queryInvalidationBus } from "./queryInvalidationBus";
import { useSocket } from "src/socket/useSocket";

type RevalidationItem = { key: QUERY_KEYS; id?: string };
type RevalidationPayload = QUERY_KEYS[] | RevalidationItem[];

export const LiveInvalidationProvider = () => {
  const isOffline = useAuthStore(state => state.isOffline);
  const socket = useSocket();

  useEffect(() => {
    if (!socket || isOffline) return;

    const handler = async (payload: RevalidationPayload = []) => {
      const items: RevalidationItem[] = (payload as any[]).map(x =>
        typeof x === "string"
          ? { key: x as QUERY_KEYS }
          : (x as RevalidationItem)
      );

      await queryInvalidationBus.notify(items);
    };

    const onConnectOrReconnect = () => {
      if (queryInvalidationBus.hasSubscribers()) {
        queryInvalidationBus.notify(
          queryInvalidationBus.getSubscribers().map(key => ({ key }))
        );
      }
    };

    socket.on(SOCKET_EVENTS.REVALIDATE_QUERY_KEYS, handler);
    socket.on("connect", onConnectOrReconnect);
    socket.on("reconnect", onConnectOrReconnect);

    return () => {
      socket.off(SOCKET_EVENTS.REVALIDATE_QUERY_KEYS, handler);
      socket.off("connect", onConnectOrReconnect);
      socket.off("reconnect", onConnectOrReconnect);
    };
  }, [socket, isOffline]);

  return null;
};
